export default "__VITE_ASSET__fdb8a5cb__"